import React from 'react'
import Screen from 'containers/Screen'

import getRoute from 'utils/getRoute'
import routes from 'config/routes'

import Products from 'containers/PromoMaior/Products'

import 'styles/BackButton.css'

export default function PromoMaiorScreen () {
  return (
    <React.Fragment>
      <Screen horizontalPadded title='Combine do seu jeito!' setHeadTitle setPrimary titleStyles={{ fontSize: 32 }} Side={Back}>
        <Products />
      </Screen>

    </React.Fragment>
  )
}


const Back = () => {
  const to = '/app' + getRoute(routes.promoMaior)
  return <div><a href={to} className="BackButton">Voltar</a></div>
}